export default {
  "walletChangeList.title": "账变记录",
  "walletChangeList.action.details": "详情",
  "walletChangeList.copy.success": "已复制到剪贴板",
  "walletChangeList.tooltip.copy.userNo": "复制会员ID: {text}",
  "walletChangeList.tooltip.copy.recordNo": "复制记录编号: {text}",
  "walletChangeList.tooltip.copy.sourceId": "复制来源ID: {text}",
  "walletChangeList.tooltip.showUserDetails": "显示用户详情",
  "walletChangeList.modal.title.details": "详情",
  "walletChangeList.modal.title.userDetails": "用户详情",
  "walletChangeList.column.no": "#序号",
  "walletChangeList.column.recordNo": "记录编号",
  "walletChangeList.column.userNo": "会员ID",
  "walletChangeList.column.sourceId": "来源ID",
  "walletChangeList.column.beforeBalance": "变更前余额",
  "walletChangeList.column.amount": "变动金额",
  "walletChangeList.column.afterBalance": "变更后余额",
  "walletChangeList.column.beforeBonusAmount": "变更前奖金",
  "walletChangeList.column.bonusAmount": "奖金变动",
  "walletChangeList.column.afterBonusAmount": "变更后奖金",
  "walletChangeList.column.beforeBonusWager": "变更前奖金流水",
  "walletChangeList.column.afterBonusWager": "变更后奖金流水",
  "walletChangeList.column.beforeWithdrawLimit": "变更前提现限制",
  "walletChangeList.column.afterWithdrawLimit": "变更后提现限制",
  "walletChangeList.column.sourceType": "记录类型",
  "walletChangeList.column.sourceDetail": "来源详情",
  "walletChangeList.column.remark": "备注",
  "walletChangeList.column.operator": "操作人",
  "walletChangeList.column.createTime": "创建时间",
  "walletChangeList.column.action": "操作",
  "walletChangeList.search.recordNo": "记录编号",
  "walletChangeList.search.userNo": "会员ID",
  "walletChangeList.search.sourceType": "记录类型",
  "walletChangeList.search.createTime": "创建时间",
};
